import * as t from 'io-ts';

import { Enum } from '../utils/mapping';

export enum UserType {
  DirOfOperations = 'DirOfOperations',
  GeneralUserFranchisee = 'GeneralUserFranchisee',
  MultiUnitManager = 'MultiUnitManager',
  ReportingAdministrator = 'ReportingAdministrator',
  ReportingOperator = 'ReportingOperator',
  RestaurantManager = 'RestaurantManager',
  VPOperations = 'VPOperations',
}

export const TStoreEmails = t.string;

export const TStoreEmailCategorizations = t.partial({
  [UserType.DirOfOperations]: t.array(TStoreEmails),
  [UserType.GeneralUserFranchisee]: t.array(TStoreEmails),
  [UserType.MultiUnitManager]: t.array(TStoreEmails),
  [UserType.ReportingAdministrator]: t.array(TStoreEmails),
  [UserType.ReportingOperator]: t.array(TStoreEmails),
  [UserType.RestaurantManager]: t.array(TStoreEmails),
  [UserType.VPOperations]: t.array(TStoreEmails),
});

export const TStoreId = t.string;

export const TUserType = new Enum<UserType>(UserType);

export const TFranOrgBody = t.record(t.string, TStoreEmailCategorizations);

export interface IFranOrgBody extends t.TypeOf<typeof TFranOrgBody> {}
